import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { Redirect } from 'react-router-dom';
import Cookie from 'js-cookie';
import Sidebar from "./Sidebar";
import RoutePath from './RoutePath';
import { getUserAuthorizations } from './Authorization';
import { ContextProvider } from './MyContext';
import "react-datepicker/dist/react-datepicker.css";

class Template extends PureComponent {
    constructor() {
        super();
        this.state = {
            user_authorizations: {}
        }
    }
    componentDidMount() {
        this.getUserAuthorizations();
    }
    getUserAuthorizations = async () => {
        let user_authorizations = await getUserAuthorizations();
        this.setState({
            user_authorizations
        })
    }
    render() {
        return (Cookie.get('token') ? (this.props.isLoading ?
            <div className="d-flex justify-content-center align-items-center" style={{ minHeight: '100vh' }}>
                <div className="spinner-border" role="status">
                    <span className="sr-only">Loading...</span>
                </div>
            </div> :
            <ContextProvider value={{
                user_authorizations: this.state.user_authorizations
            }}>
                <div className="d-flex" id="wrapper" style={{ minWidth: 1200, overflow: 'auto' }}>
                    <Sidebar />
                    <div className="w-100 bgc-F9F9F9" style={{ height: '100vh', overflow: 'auto' }}>
                        {this.props.children}
                    </div>
                </div>
            </ContextProvider>)
            : <Redirect to={RoutePath.LOGIN} />);
    }
}

Template.propTypes = {
    isLoading: PropTypes.bool
};
Template.defaultProps = {
    isLoading: false
}

export default Template;